<template>
  <form
    ref="form"
    enctype="multipart/form-data"
  >
    <div class="row">
      <div class="col-xs-12">
        <fg-input
          v-model="model.description"
          type="text"
          label="Description"
          placeholder="Description"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <label>Attach New File</label>
        <input
          id="fileUpload"
          ref="file"
          type="file"
          name="files"
          style="display: none"
          multiple
          @change="filePicked"
        >
        <div>
          <button
            type="button"
            class="btn btn-primary btn-wd"
            @click="chooseFiles()"
          >
            Choose
          </button>
        </div>
        <ul>
          <li
            v-for="file in model.files"
            :key="file.id"
          >
            <span v-if="!file.id">
              {{ file.name }}
            </span>
          </li>
        </ul>
      </div>
      <div
        v-if="model.attachments.length"
        class="col-sm-6"
      >
        <label>Attached Files</label>
        <ul>
          <li
            v-for="file in model.attachments"
            :key="file.id"
          >
            <span v-if="file.id">
              {{ file.original_name }}
              <i
                class="fas fa-times fa-1x"
                @click="deleteFile(model, file)"
              />
            </span>
          </li>
        </ul>
      </div>
    </div>

    <div
      id="e"
      class="row mt-5"
    >
      <div class="col-xs-12">
        <label>Notes</label>
        <quill-editor
          ref="myQuillEditor"
          v-model="model.notes"
          :options="editorOption"
        />
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-xs-12">
        <fg-input
          v-model="model.issued_at"
          type="date"
          label="Issued at"
          placeholder="issued_at"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <fg-input
          v-model="model.expiry_at"
          type="date"
          label="Expiry at"
          placeholder="expiry_at"
        />
      </div>
    </div>

    <div
      v-if="model.expiry_at"
      class="row"
    >
      <div class="col-sm-12">
        <label>Expiry warnings</label>

        <div class="row">
          <div class="col-sm-2">
            <div>
              <p-switch
                :value="model.manager"
                type="primary"
                class="mr-xs"
                @input="toggleWarning('manager')"
              />
              <label>Manager</label>
            </div>
            <div>
              <p-switch
                :value="model.trainee"
                type="primary"
                class="mr-xs"
                @input="toggleWarning('trainee')"
              />
              <label>Trainee</label>
            </div>
          </div>
          <div
            v-if="model.manager || model.trainee"
            class="col-sm-10"
          >
            <div
              v-for="(reminder, index) in model.reminders"
              :key="index"
              class="col-sm-4"
            >
              <fg-input
                v-model="reminder.value"
                label="Day(s) prior to expiry"
                type="number"
                min="0"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import PSwitch from "@components/UIComponents/Switch.vue";

export default {
  components: {
    quillEditor,
    PSwitch
  },
  props: {
    event: {
      type: Object,
      default: () => {}
    }
  },
  emits: ["eventDeleteFile"],
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ align: [] }],
            ["clean"]
          ]
        }
      }
    };
  },
  computed: {
    model() {
      return this.event;
    }
  },
  methods: {
    async chooseFiles() {
      document.getElementById("fileUpload").click();
    },
    filePicked(e) {
      this.model.files = e.target.files;
    },
    deleteFile(event, file) {
      this.$emit("eventDeleteFile", { event, file });
    },
    toggleWarning(type) {
      return (this.model[type] = !this.model[type]);
    }
  }
};
</script>

<style lang="scss"></style>
